<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('tuevs.component.form.fields.codigo.label')" label-for="input-codigo">
          <b-form-input id="input-codigo" v-model="component.code" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('tuevs.component.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="component.name" type="text"/>
        </b-form-group>

        <b-form-group
            :label="$t('tuevs.component.form.fields.status.label')"
            label-for="input-status"
            :description="$t('tuevs.component.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="component.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('tuevs.component.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ComponentRepository from '@/repositories/tuevs/ComponentRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  data() {
    return {
      component_id: null
    }
  },
  computed: {
    ...mapGetters({
      component: 'tuevs/component/current',
      isLoading: 'tuevs/component/isLoading'
    }),
    pageTitle() {
      if (this.component_id) return this.$t('tuevs.component.form.titulo_pagina.editar')
      return this.$t('tuevs.component.form.titulo_pagina.criar')
    }
  },
  async mounted() {
    this.$store.commit('tuevs/component/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.component_id = this.$route.params.id
      await this['tuevs/component/listOne'](this.$route.params.id)
    }
  },
  methods: {
    ...mapActions([
      'tuevs/component/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      ComponentRepository.post(this.component).then(() => {
        this.$snotify.success(this.$t('tuevs.component.form.create.success'))
        this.$router.push({name: 'tuevs.component'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.component.form.create.error'))
        if (error.response.status === 422) {
          ComponentRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      ComponentRepository.put(this.component_id, this.component).then(() => {
        this.$snotify.success(this.$t('tuevs.component.form.update.success'))
        this.$router.push({name: 'tuevs.component'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.component.form.update.error'))
        if (error.response.status === 422) {
          ComponentRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
